/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  DetailedRoute,
  GetRoutesWithPositionsParams,
  GetTargetRoutesParams,
  RoutesResult
} from '../../model';





/**
 * Can be used for getting routes for one target.
 * @summary Get routes in JSON
 */
export const getTargetRoutes = (
    targetId: number,
    params: GetTargetRoutesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DetailedRoute[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targets/${targetId}/routes`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetTargetRoutesQueryKey = (targetId?: number,
    params?: GetTargetRoutesParams,) => {
    return [
    `/api/v1.1/targets/${targetId}/routes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTargetRoutesQueryOptions = <TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(targetId: number,
    params: GetTargetRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetRoutesQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetRoutes>>> = ({ signal }) => getTargetRoutes(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(targetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetRoutesQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetRoutes>>>
export type GetTargetRoutesQueryError = AxiosError<unknown>


export function useGetTargetRoutes<TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetTargetRoutesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetRoutes>>,
          TError,
          Awaited<ReturnType<typeof getTargetRoutes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetRoutes<TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetTargetRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetRoutes>>,
          TError,
          Awaited<ReturnType<typeof getTargetRoutes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetRoutes<TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetTargetRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get routes in JSON
 */

export function useGetTargetRoutes<TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetTargetRoutesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetRoutesQueryOptions(targetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTargetRoutesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(targetId: number,
    params: GetTargetRoutesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetRoutesQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetRoutes>>> = ({ signal }) => getTargetRoutes(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetRoutesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetRoutes>>>
export type GetTargetRoutesSuspenseQueryError = AxiosError<unknown>


export function useGetTargetRoutesSuspense<TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetTargetRoutesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetRoutesSuspense<TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetTargetRoutesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetRoutesSuspense<TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetTargetRoutesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get routes in JSON
 */

export function useGetTargetRoutesSuspense<TData = Awaited<ReturnType<typeof getTargetRoutes>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetTargetRoutesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargetRoutes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargetRoutesSuspenseQueryOptions(targetId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for getting routes for one target.
 * @summary Get routes in JSON
 */
export const getRoutesWithPositions = (
    targetId: number,
    params: GetRoutesWithPositionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RoutesResult>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targets/${targetId}/routes/v2`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetRoutesWithPositionsQueryKey = (targetId?: number,
    params?: GetRoutesWithPositionsParams,) => {
    return [
    `/api/v1.1/targets/${targetId}/routes/v2`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetRoutesWithPositionsQueryOptions = <TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(targetId: number,
    params: GetRoutesWithPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoutesWithPositionsQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoutesWithPositions>>> = ({ signal }) => getRoutesWithPositions(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(targetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoutesWithPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRoutesWithPositions>>>
export type GetRoutesWithPositionsQueryError = AxiosError<unknown>


export function useGetRoutesWithPositions<TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetRoutesWithPositionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoutesWithPositions>>,
          TError,
          Awaited<ReturnType<typeof getRoutesWithPositions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoutesWithPositions<TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetRoutesWithPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoutesWithPositions>>,
          TError,
          Awaited<ReturnType<typeof getRoutesWithPositions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoutesWithPositions<TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetRoutesWithPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get routes in JSON
 */

export function useGetRoutesWithPositions<TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetRoutesWithPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoutesWithPositionsQueryOptions(targetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetRoutesWithPositionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(targetId: number,
    params: GetRoutesWithPositionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoutesWithPositionsQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoutesWithPositions>>> = ({ signal }) => getRoutesWithPositions(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoutesWithPositionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRoutesWithPositions>>>
export type GetRoutesWithPositionsSuspenseQueryError = AxiosError<unknown>


export function useGetRoutesWithPositionsSuspense<TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetRoutesWithPositionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoutesWithPositionsSuspense<TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetRoutesWithPositionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoutesWithPositionsSuspense<TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetRoutesWithPositionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get routes in JSON
 */

export function useGetRoutesWithPositionsSuspense<TData = Awaited<ReturnType<typeof getRoutesWithPositions>>, TError = AxiosError<unknown>>(
 targetId: number,
    params: GetRoutesWithPositionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoutesWithPositions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoutesWithPositionsSuspenseQueryOptions(targetId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




